import React from 'react'
import CountItem from './CountItem'

const IllustrationBox = ({number, title, text, image, className, suffix = ``, alignment = `center`}) => (
  <div className="illustration-box flex flex-col items-center">
    { image ? <img className="w-1/2" src={`/AnnualReport2017-2018${image}`} alt="" /> : null }

    <CountItem to={number} className={`text-xl text-blue-600 ${className}`} suffix={suffix} />

    <div className="text-center text-lg my-2">{title}</div>
    <div className={`w-full text-${alignment} ${alignment === 'left' ? 'text-justify' : ''} text-sm font-normal`}>{text}</div>
  </div>
)

export default IllustrationBox
